/**
 * Clases del logo del header público (LandingHeader), separadas para poder testear el contrato.
 *
 * El bug: el `<Link>` del logo tenía `min-w-0`, así que flex le achicaba la CAJA pero la palabra
 * "AcademIA" no se achica (un logotipo no se trunca) y se pintaba por debajo de lo que venía
 * después. En 320px "Ingresá" quedaba encima de la "IA"; con algo en el carrito, el ícono del
 * carrito tapaba la palabra hasta en 390px.
 *
 * Ahora el logo NUNCA se encoge (`shrink-0`) y el ancho se libera de antemano:
 *
 * - Debajo de 360px la palabra baja a 18px (logo ~125px): con "Ingresá" + "Registrate" (~156px)
 *   y el padding lateral entra en 320px con aire.
 * - Si el carrito está a la vista (+48px a la derecha), debajo de 420px se oculta la palabra y
 *   queda el isotipo; el nombre sigue en el `aria-label` del link. Se resuelve con `:has()` en
 *   CSS y no con el store en React: el carrito vive en localStorage, el SSR no lo conoce, y una
 *   clase distinta entre servidor y cliente es un mismatch de hidratación que React no corrige.
 *
 * Los strings son literales completos a propósito: Tailwind los detecta escaneando el código.
 */
export const HEADER_NAV_GROUP_CLASSNAME = "group/nav";

export const HEADER_LOGO_LINK_CLASSNAME =
  "font-display flex shrink-0 items-center gap-1.5 text-lg font-semibold tracking-tight min-[360px]:gap-2 min-[360px]:text-2xl";

export const HEADER_WORDMARK_CLASSNAME =
  "flex items-baseline max-[419px]:group-has-[[data-cart-icon]]/nav:hidden";
